import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CoveredByThd from './CoveredByThd';
import loading from '../../../../actions/loading';
import loaded from '../../../../actions/loaded';
import globalError from '../../../../actions/globalError';
import config from '../../../../helpers/config';
import { sites } from '../../../../helpers/globalVariables';

const buildEmptyWindow = label => ({
  label,
  autobahnEstimateGuid: '00000000-0000-0000-0000-000000000000',
  color: '',
  height: '',
  width: '',
  productId: 0,
});

const itemsWithExtraQuantity = {};

const getProductId = (skuNumber, productMap) => {
  if (config.siteId === sites.theHomeDepot) {
    if (productMap && productMap.partnerProductIdToProductIdMap[skuNumber]) {
      return productMap.partnerProductIdToProductIdMap[skuNumber];
    }

    globalError();
  }

  return skuNumber;
};

const isEligible = (productId, eligibleProducts) => {
  const ep = eligibleProducts.find(entry => entry.skuNumber === productId);
  if (ep && ep.eligible) {
    return true;
  }

  return false;
};

const toShoppingSessionWindow = (estimateBuilderItem, index, eligibleProducts, productMap) => {
  const { itemProduct, quantity } = estimateBuilderItem;

  if (quantity > 1) {
    // Tracking extra quantity to pass to mandi to generate
    // new configurationguids for each additional quantity
    itemsWithExtraQuantity[itemProduct.configurationGuid] = quantity - 1;
  }

  const label = (index + 1).toString();

  if (!itemProduct) {
    return buildEmptyWindow(label);
  }

  const {
    productName, configurationGuid, attributes, skuNumber,
  } = estimateBuilderItem.itemProduct;

  const productId = getProductId(skuNumber, productMap);

  if (!isEligible(productId, eligibleProducts)) {
    return buildEmptyWindow(label);
  }

  const colorAttribute = attributes.find(attribute => attribute.name === 'Color');
  const heightAttribute = attributes.find(attribute => attribute.name === 'Height');
  const widthAttribute = attributes.find(attribute => attribute.name === 'Width');

  return {
    label,
    productName,
    autobahnEstimateGuid: configurationGuid,
    // Some Custom products do not have a Color attribute.
    color: colorAttribute === undefined ? '' : colorAttribute.value,
    height: heightAttribute.value,
    width: widthAttribute.value,
    productId,
  };
};

const mapStateToProps = ({ estimateBuilder }) => {
  const {
    validationResult,
    eligibilityList,
    allProductsEligible,
    productMap,
  } = estimateBuilder.mandiAvailability;
  const { selectedEstimate } = estimateBuilder.uiState;
  const { items, containers, estimates } = estimateBuilder.entities;

  const configurations = items.allIds.reduce((result, itemId) => {
    const item = items.byId[itemId];
    if (item.designId === selectedEstimate && item.itemProduct) {
      const { configurationGuid, retail, skuNumber } = item.itemProduct;

      const productId = getProductId(skuNumber, productMap);

      if (isEligible(productId, eligibilityList)) {
        result.push({ configurationGuid, price: retail });
      }
    }
    return result;
  }, []);

  const shoppingSessionRooms = estimates.byId[selectedEstimate].containers.map((id, index) => {
    const { containerId, name } = containers.byId[id];

    return {
      label: String.fromCharCode(index + 65),
      name,
      windows: Object.values(items.byId)
        .filter(item => item.containerId === containerId)
        .map((givenItem, idx) =>
          toShoppingSessionWindow(givenItem, idx, eligibilityList, productMap)),
    };
  });

  return {
    ...validationResult,
    configurations,
    selectedEstimate,
    measureAndInstallEstimate: {
      name: estimates.byId[selectedEstimate].name,
      rooms: shoppingSessionRooms,
    },
    allProductsEligible,
    itemsWithExtraQuantity,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ loading, loaded, globalError }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CoveredByThd);
